// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetDashboardAreaId } from './FleetDashboardAreaId'
import { FleetDashboardAreaNavigation } from './FleetDashboardAreaNavigation'
import { FleetDashboardAreaRoutes } from './FleetDashboardAreaRoutes'

const LazyFleetDashboardComponent = lazy(() => import('./FleetDashboardArea'))

const FleetDashboardComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetDashboardComponent />
  </SuspenseLoadingWrapper>
)

export const FleetDashboardArea = {
  id: FleetDashboardAreaId,
  requiredRight: BoumRight.AREA_VEHICLE,
  NavigationComponent: FleetDashboardAreaNavigation,
  route: {
    path: FleetDashboardAreaRoutes.route,
    component: FleetDashboardComponent,
  },
}
